// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file order/v1/order.proto (package order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Discount, Product, TaxRate, TransactionCharge } from "./pricing_pb";
import { Channel, CheckoutOptions, Money, OrderOrigination, RefundPaymentMethod, ShippingMethod as ShippingMethod$1 } from "../../common/v1/common_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";

/**
 * Indicates order status.
 *
 * @generated from enum order.v1.OrderStatus
 */
export const OrderStatus = proto3.makeEnum(
  "order.v1.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_CREATED", localName: "CREATED"},
    {no: 2, name: "ORDER_STATUS_SUBMITTED", localName: "SUBMITTED"},
    {no: 3, name: "ORDER_STATUS_COMPLETED", localName: "COMPLETED"},
    {no: 4, name: "ORDER_STATUS_CANCELLED", localName: "CANCELLED"},
    {no: 5, name: "ORDER_STATUS_REFUNDED", localName: "REFUNDED"},
    {no: 6, name: "ORDER_STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * Order split type
 *
 * @generated from enum order.v1.OrderSplitType
 */
export const OrderSplitType = proto3.makeEnum(
  "order.v1.OrderSplitType",
  [
    {no: 0, name: "ORDER_SPLIT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_SPLIT_TYPE_UNDIVIDED", localName: "UNDIVIDED"},
    {no: 2, name: "ORDER_SPLIT_TYPE_SPLIT", localName: "SPLIT"},
    {no: 3, name: "ORDER_SPLIT_TYPE_SPLIT_PAY_IN", localName: "SPLIT_PAY_IN"},
  ],
);

/**
 * @generated from enum order.v1.RetryType
 */
export const RetryType = proto3.makeEnum(
  "order.v1.RetryType",
  [
    {no: 0, name: "RETRY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RETRY_TYPE_PAYMENT", localName: "PAYMENT"},
    {no: 3, name: "RETRY_TYPE_NO_OP", localName: "NO_OP"},
  ],
);

/**
 * @generated from enum order.v1.RefundStatus
 */
export const RefundStatus = proto3.makeEnum(
  "order.v1.RefundStatus",
  [
    {no: 0, name: "REFUND_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REFUND_STATUS_INITIATED", localName: "INITIATED"},
    {no: 2, name: "REFUND_STATUS_ACCEPTED", localName: "ACCEPTED"},
    {no: 3, name: "REFUND_STATUS_DECLINED", localName: "DECLINED"},
    {no: 4, name: "REFUND_STATUS_COMPLETED", localName: "COMPLETED"},
    {no: 5, name: "REFUND_STATUS_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from enum order.v1.CancelStatus
 */
export const CancelStatus = proto3.makeEnum(
  "order.v1.CancelStatus",
  [
    {no: 0, name: "CANCEL_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CANCEL_STATUS_INITIATED", localName: "INITIATED"},
    {no: 2, name: "CANCEL_STATUS_ACCEPTED", localName: "ACCEPTED"},
    {no: 3, name: "CANCEL_STATUS_DECLINED", localName: "DECLINED"},
    {no: 4, name: "CANCEL_STATUS_COMPLETED", localName: "COMPLETED"},
    {no: 5, name: "CANCEL_STATUS_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from enum order.v1.TipStatus
 */
export const TipStatus = proto3.makeEnum(
  "order.v1.TipStatus",
  [
    {no: 0, name: "TIP_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TIP_STATUS_INITIATED", localName: "INITIATED"},
    {no: 2, name: "TIP_STATUS_ACCEPTED", localName: "ACCEPTED"},
    {no: 3, name: "TIP_STATUS_DECLINED", localName: "DECLINED"},
    {no: 4, name: "TIP_STATUS_COMPLETED", localName: "COMPLETED"},
    {no: 5, name: "TIP_STATUS_ERROR", localName: "ERROR"},
  ],
);

/**
 * Order line item
 *
 * @generated from message order.v1.LineItem
 */
export const LineItem = proto3.makeMessageType(
  "order.v1.LineItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "price", kind: "message", T: LineItem_Price },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "catalog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "product", kind: "message", T: Product },
    { no: 7, name: "transaction_charges", kind: "message", T: TransactionCharge, repeated: true },
    { no: 8, name: "discounts", kind: "message", T: Discount, repeated: true },
    { no: 9, name: "tax_rates", kind: "message", T: TaxRate, repeated: true },
    { no: 10, name: "total_fee_amount", kind: "message", T: Money },
    { no: 21, name: "transaction_discount_amount", kind: "message", T: Money },
    { no: 19, name: "total_discount_percent", kind: "message", T: Money },
    { no: 12, name: "total_tax_amount", kind: "message", T: Money },
    { no: 22, name: "tax_inclusive_line_item_total_amount", kind: "message", T: Money },
    { no: 14, name: "shipping_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "shipping_method", kind: "message", T: ShippingMethod$1 },
    { no: 16, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 17, name: "total_shipping_amount", kind: "message", T: Money },
    { no: 18, name: "sub_total_amount", kind: "message", T: Money },
    { no: 20, name: "merchant_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "line_item_unit_of_measure_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message order.v1.LineItem.Price
 */
export const LineItem_Price = proto3.makeMessageType(
  "order.v1.LineItem.Price",
  () => [
    { no: 1, name: "unit_price", kind: "message", T: Money },
  ],
  {localName: "LineItem_Price"},
);

/**
 * Internal order
 * Next id : 37
 *
 * @generated from message order.v1.Order
 */
export const Order = proto3.makeMessageType(
  "order.v1.Order",
  () => [
    { no: 1, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 3, name: "total", kind: "message", T: Money },
    { no: 4, name: "total_shipping", kind: "message", T: Money },
    { no: 5, name: "total_discount", kind: "message", T: Money },
    { no: 6, name: "total_tax", kind: "message", T: Money },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "updated_at", kind: "message", T: Timestamp },
    { no: 9, name: "line_items", kind: "message", T: LineItem, repeated: true },
    { no: 10, name: "subtotal", kind: "message", T: Money },
    { no: 11, name: "shipping_address_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "shipping_methods", kind: "message", T: ShippingMethod, repeated: true },
    { no: 14, name: "merchant_settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "order_origination", kind: "enum", T: proto3.getEnumType(OrderOrigination) },
    { no: 16, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "refunds", kind: "message", T: Refund, repeated: true },
    { no: 21, name: "total_refund", kind: "message", T: Money },
    { no: 22, name: "transaction_charges", kind: "message", T: TransactionCharge, repeated: true },
    { no: 23, name: "total_fee_amount", kind: "message", T: Money },
    { no: 24, name: "discounts", kind: "message", T: Discount, repeated: true },
    { no: 25, name: "tax_rates", kind: "message", T: TaxRate, repeated: true },
    { no: 26, name: "total_duty_amount", kind: "message", T: Money },
    { no: 27, name: "total_value_added_tax_amount", kind: "message", T: Money },
    { no: 28, name: "total_value_added_tax_percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "total_shipping_value_added_tax_amount", kind: "message", T: Money },
    { no: 30, name: "total_shipping_value_added_tax_percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "total_alternate_tax_amount", kind: "message", T: Money },
    { no: 32, name: "total_gratuity_amount", kind: "message", T: Money },
    { no: 33, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "split_type", kind: "enum", T: proto3.getEnumType(OrderSplitType) },
    { no: 35, name: "total_transaction_amount", kind: "message", T: Money },
    { no: 36, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "cancels", kind: "message", T: Cancel, repeated: true },
    { no: 38, name: "channel", kind: "message", T: Channel },
    { no: 39, name: "surcharge_amount", kind: "message", T: Money },
    { no: 40, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "children", kind: "message", T: Order, repeated: true },
    { no: 42, name: "ship_from_address_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "transaction_advices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 44, name: "value_added_tax_invoice_reference_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "party_tax_government_issued_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "tax_treatment_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message order.v1.OrderRetry
 */
export const OrderRetry = proto3.makeMessageType(
  "order.v1.OrderRetry",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "retry_type", kind: "enum", T: proto3.getEnumType(RetryType) },
    { no: 3, name: "retry_countdown", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "max_retry_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message order.v1.ShippingMethod
 */
export const ShippingMethod = proto3.makeMessageType(
  "order.v1.ShippingMethod",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shipping_cost", kind: "message", T: Money },
    { no: 5, name: "estimated_delivery_date", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message order.v1.TemplateOrder
 */
export const TemplateOrder = proto3.makeMessageType(
  "order.v1.TemplateOrder",
  () => [
    { no: 1, name: "total", kind: "message", T: Money },
    { no: 2, name: "total_shipping", kind: "message", T: Money },
    { no: 3, name: "total_discount", kind: "message", T: Money },
    { no: 4, name: "total_tax", kind: "message", T: Money },
    { no: 8, name: "total_transactional_charge_amount", kind: "message", T: Money },
    { no: 5, name: "line_items", kind: "message", T: LineItem, repeated: true },
    { no: 6, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "checkout_options", kind: "message", T: CheckoutOptions },
    { no: 9, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "transaction_charges", kind: "message", T: TransactionCharge, repeated: true },
    { no: 11, name: "discounts", kind: "message", T: Discount, repeated: true },
    { no: 12, name: "tax_rates", kind: "message", T: TaxRate, repeated: true },
    { no: 13, name: "subtotal", kind: "message", T: Money },
    { no: 14, name: "total_duty_amount", kind: "message", T: Money },
    { no: 15, name: "total_value_added_tax_amount", kind: "message", T: Money },
    { no: 16, name: "total_value_added_tax_percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "total_shipping_value_added_tax_amount", kind: "message", T: Money },
    { no: 18, name: "total_shipping_value_added_tax_percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "total_alternate_tax_amount", kind: "message", T: Money },
    { no: 20, name: "total_gratuity_amount", kind: "message", T: Money },
    { no: 21, name: "tax_treatment_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "transaction_advices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 23, name: "value_added_tax_invoice_reference_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "party_tax_government_issued_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "total_fee_amount", kind: "message", T: Money },
  ],
);

/**
 * @generated from message order.v1.Refund
 */
export const Refund = proto3.makeMessageType(
  "order.v1.Refund",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total", kind: "message", T: Money },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(RefundStatus) },
    { no: 7, name: "refund_payment_method", kind: "enum", T: proto3.getEnumType(RefundPaymentMethod) },
    { no: 8, name: "initiated_by_checkout", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
    { no: 11, name: "remaining_refundable_amount", kind: "message", T: Money },
    { no: 12, name: "payment_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message order.v1.Cancel
 */
export const Cancel = proto3.makeMessageType(
  "order.v1.Cancel",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(CancelStatus) },
    { no: 8, name: "initiated_by_checkout", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
    { no: 12, name: "payment_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

